module.exports = __webpack_public_path__ + "static/media/gallery-5.5c6019dc.jpg";